import { render, staticRenderFns } from "./ReceivedPix.vue?vue&type=template&id=7cc0af74&"
import script from "./ReceivedPix.vue?vue&type=script&lang=js&"
export * from "./ReceivedPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc0af74')) {
      api.createRecord('7cc0af74', component.options)
    } else {
      api.reload('7cc0af74', component.options)
    }
    module.hot.accept("./ReceivedPix.vue?vue&type=template&id=7cc0af74&", function () {
      api.rerender('7cc0af74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/internet-banking/ReceivedPix.vue"
export default component.exports